/*
 * @Author: Liux
 * @Date: 2019-12-04 01:31:50
 * @LastEditor: Liux
 * @LastEditTime : 2019-12-20 02:43:21
 */
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdTextComponent } from './ad-text.component';

@NgModule({
  declarations: [AdTextComponent],
  imports: [CommonModule, FormsModule],
  exports: [AdTextComponent]
})
export class AdTextModule {}

export { AdTextComponent };
